<template>
  <div class="def-counter">
    <div class="def-counter__control" @click="handlerReduce">
      <svg class="def-counter__icon">
        <use xlink:href="#svg-minus"></use>
      </svg>
    </div>
    <input type="input" class="def-counter__input" :value="count" @change="handlerChange" />
    <div class="def-counter__control" @click="handlerIncrease">
      <svg class="def-counter__icon">
        <use xlink:href="#svg-plus"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Analytics from '@/utils/Analytics';

export default {
  name: 'DefCounter',
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      min: 1,
      max: 999,
      step: 1,
    };
  },
  computed: {
    count() {
      return parseInt(this.result.count);
    },
    basketId() {
      return this.result.basket_id;
    },
  },
  methods: {
    ...mapActions({
      basketUpdate: 'basket/update',
    }),
    async update(count) {
      await this.basketUpdate({
        id: this.result?.offer?.id || this.result.id,
        // basketId: this.result.basket_id,
        count,
      });
      Analytics.updatedBasket();
      this.$emit('updated');
    },
    handlerIncrease() {
      if (this.count >= this.max) return;
      this.update(this.count + this.step);
    },
    handlerReduce() {
      if (this.count <= this.min) return;
      this.update(this.count - this.step);
    },
    handlerChange({ target }) {
      const value = Number(target.value);

      if (value >= this.max) {
        this.update(this.max);
        target.value = this.max;
      } else if (value <= this.min) {
        this.update(this.min);
        target.value = this.min;
      } else {
        this.update(value);
      }
    },
  },
};
</script>

<style lang="scss">
.def-counter {
  display: flex;
  border: 1px solid var(--border-grey);
  height: 32px;
  width: 100px;
  &__input {
    width: 34px;
    flex-shrink: 0;
    padding: 0;
    text-align: center;
    border: none;
    background-color: transparent;
    transform: translateY(1px);
    color: #030304;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    &:focus {
      outline: none;
    }
  }
  &__control {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    &:hover {
      cursor: pointer;
    }
  }
  &__icon {
    fill: #3f3f3f;
    width: 20px;
    height: 20px;
  }
  & > div:first-child {
    border-right: 1px solid var(--border-grey);
  }
  & > div:last-child {
    border-left: 1px solid var(--border-grey);
  }
}
</style>
